import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { refreshToken } from "../redux/authTeacher/operation.js";
import { setRefreshComplete } from "../redux/authTeacher/slice.js";
import { selectIsLoggedIn } from "../redux/authTeacher/selector.js";
import { useLocation } from "react-router-dom";
import { getInitialRole } from "../utils/getInitialRole.js";

const useAuthInit = () => {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const hasAttemptedRef = useRef(false); // 🔒 защита
  const location = useLocation();

  useEffect(() => {
    // if (location.pathname === "/verify-teacher-email") {
    //   dispatch(setRefreshComplete());
    //   return;
    // }
    const role = getInitialRole();
    if (role === "student" || role === null) {
      dispatch(setRefreshComplete());
      return;
    }
    const skipRefreshRoutes = [
      "/verify-teacher-email",
      "/verify-student-email",
      "/reset-password",
    ];
    if (skipRefreshRoutes.includes(location.pathname)) {
      dispatch(setRefreshComplete());
      return;
    }
    if (hasAttemptedRef.current) return; // 🛑 уже была попытка

    const init = async () => {
      hasAttemptedRef.current = true;

      try {
        if (!isLoggedIn) {
          await dispatch(refreshToken()).unwrap();
        }
        // await dispatch(fetchTeacherSubscription());
        // eslint-disable-next-line no-unused-vars
      } catch (_) {
        // ignore errors
      } finally {
        dispatch(setRefreshComplete()); // разблокировка UI
      }
    };

    init();
  }, [dispatch, isLoggedIn, location.pathname]);
};

export default useAuthInit;
